module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subpage addrule_edit"
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules,
      "show-message": true,
      "label-position": "right",
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "SEO标题"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "placeholder": "请输入SEO标题"
    },
    model: {
      value: (_vm.params.seoKeyword),
      callback: function($$v) {
        _vm.$set(_vm.params, "seoKeyword", $$v)
      },
      expression: "params.seoKeyword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "SEO关键字"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "placeholder": "请输入SEO关键字"
    },
    model: {
      value: (_vm.params.seoTitle),
      callback: function($$v) {
        _vm.$set(_vm.params, "seoTitle", $$v)
      },
      expression: "params.seoTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "SEO描述"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "placeholder": "请输入SEO描述"
    },
    model: {
      value: (_vm.params.seoDesc),
      callback: function($$v) {
        _vm.$set(_vm.params, "seoDesc", $$v)
      },
      expression: "params.seoDesc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "浏览量"
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.params.views),
      callback: function($$v) {
        _vm.$set(_vm.params, "views", $$v)
      },
      expression: "params.views"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "信息页模版"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "placeholder": "请输入信息页模版"
    },
    model: {
      value: (_vm.params.modelLink),
      callback: function($$v) {
        _vm.$set(_vm.params, "modelLink", $$v)
      },
      expression: "params.modelLink"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "自定义链接"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "placeholder": "请输入自定义链接"
    },
    model: {
      value: (_vm.params.customLink),
      callback: function($$v) {
        _vm.$set(_vm.params, "customLink", $$v)
      },
      expression: "params.customLink"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "排序"
    }
  }, [_c('el-input-number', {
    attrs: {
      "controls-position": "right",
      "min": 0
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.params.weight),
      callback: function($$v) {
        _vm.$set(_vm.params, "weight", $$v)
      },
      expression: "params.weight"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-e8c94510"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/cms/user/professional_committee/add/src/subpage3.vue
// module id = 1581
// module chunks = 1